// material-ui
import { useTheme, styled } from "@mui/material/styles";
import {
  Avatar,
  Divider,
  Grid,
  List,

  Typography,
} from "@mui/material";

import moment from "moment";
import "moment/locale/en-in";
import "moment/locale/is";
import "moment/locale/pl";
import "moment/locale/es";
// assets
import { NotificationIconCard } from "ui-component/cards/Skeleton/TableLoader";

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = (props) => {
  const { notificationList, loading } = props;
  const lng = localStorage.getItem("i18nextLng");
  const theme = useTheme();

    if (!['en-in', 'is', 'pl', 'es'].includes(lng)) {
      console.error(`Unsupported locale: ${lng}. Defaulting to 'en'`);
      moment.locale('en');  // fallback to English if the locale is not supported
    } else {
      moment.locale(lng); // Set locale dynamically
    }

  return (
    <List
      sx={{
        width: "100%",
        width: 330,
        maxWidth: 330,
        py: 0,
        borderRadius: "10px",
        [theme.breakpoints.down("md")]: {
          maxWidth: 300,
        },
        [theme.breakpoints.down("sm")]: {
          width: '100%',
          maxWidth: 250,
        },
        "& .MuiListItemSecondaryAction-root": {
          top: 32,
        },
        "& .MuiDivider-root": {
          my: 0,
        },
        "& .list-container": {
          pl: 7,
          mt: -1,
        },
        "& .MuiListItemText-primary": {
          mt: -2,
        },
        
      }}
    >
      {!loading &&
        notificationList.docs.length > 0 &&
        notificationList.docs.map((noti, i) => (
          <>
            {/* <ListItemWrapper>
              <ListItem alignItems="center">
                <ListItemAvatar>
                  <Avatar alt="John Doe" src={noti?.owner?.profile_pic} />
                </ListItemAvatar>
                <ListItemText primary={noti?.title} />
                <ListItemSecondaryAction>
                  <Grid container justifyContent="flex-end">
                    <Grid item xs={12}>
                      <Typography
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        {moment(noti.createdAt).startOf("seconds").fromNow()}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItemSecondaryAction>
              </ListItem>
              <Grid container direction="column" className="list-container">
                <Grid item xs={12} sx={{ pb: 2 }}>
                  <Typography variant="subtitle2">{noti.content}</Typography>
                </Grid>
              </Grid>
            </ListItemWrapper> */}
            <Divider />
           

            <Grid container spacing={0.5}>
              <Grid item xs={12} sx={{ m: 2,mb:1 }}>
                <Grid container alignItems="center1" spacing={1}>
                  <Grid
                    xs={3}
                    sm={2.5}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                      {noti?.owner?.profile_pic ? <Avatar alt="John Doe" src={noti?.owner?.profile_pic}     sx={{ marginTop: "0px" }} /> :<Avatar alt="John Doe" src={noti?.user?.profile_pic}     sx={{ marginTop: "0px" }}  />}
                   
                  </Grid>
                  <Grid container xs={9} sm={9.5} spacing={0}>
                    <Grid item xs={12}>
                      <Typography  sx={{fontSize:"12px"}}>{noti?.title}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{pt:0}}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                     
                        
                      >
                        <Grid item xs={12} sm={7}>
                          <Typography variant="subtitle2">
                            {noti?.content}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={5} sx={{textAlign:'end'}}>
                          <Typography variant="caption">
                            {moment(noti.createdAt)
                              .startOf("seconds")
                              .fromNow()}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </>
        ))}
      {loading && <NotificationIconCard rows={5} />}
      {/* <ListItemWrapper>
        <ListItem alignItems="center">
          <ListItemAvatar>
            <Avatar alt="John Doe" src={User1} />
          </ListItemAvatar>
          <ListItemText primary="John Doe" />
          <ListItemSecondaryAction>
            <Grid container justifyContent="flex-end">
              <Grid item xs={12}>
                <Typography variant="caption" display="block" gutterBottom>
                  2 min ago
                </Typography>
              </Grid>
            </Grid>
          </ListItemSecondaryAction>
        </ListItem>
        <Grid container direction="column" className="list-container">
          <Grid item xs={12} sx={{ pb: 2 }}>
            <Typography variant="subtitle2">
              It is a long established fact that a reader will be distracted
            </Typography>
          </Grid>
        </Grid>
      </ListItemWrapper>
      <Divider />
      <ListItemWrapper>
        <ListItem alignItems="center">
          <ListItemAvatar>
            <Avatar alt="John Doe" src={User1} />
          </ListItemAvatar>
          <ListItemText primary="John Doe" />
          <ListItemSecondaryAction>
            <Grid container justifyContent="flex-end">
              <Grid item xs={12}>
                <Typography variant="caption" display="block" gutterBottom>
                  2 min ago
                </Typography>
              </Grid>
            </Grid>
          </ListItemSecondaryAction>
        </ListItem>
        <Grid container direction="column" className="list-container">
          <Grid item xs={12} sx={{ pb: 2 }}>
            <Typography variant="subtitle2">
              It is a long established fact that a reader will be distracted
            </Typography>
          </Grid>
        </Grid>
      </ListItemWrapper>
      <Divider />
      <ListItemWrapper>
        <ListItem alignItems="center">
          <ListItemAvatar>
            <Avatar alt="John Doe" src={User1} />
          </ListItemAvatar>
          <ListItemText primary="John Doe" />
          <ListItemSecondaryAction>
            <Grid container justifyContent="flex-end">
              <Grid item xs={12}>
                <Typography variant="caption" display="block" gutterBottom>
                  2 min ago
                </Typography>
              </Grid>
            </Grid>
          </ListItemSecondaryAction>
        </ListItem>
        <Grid container direction="column" className="list-container">
          <Grid item xs={12} sx={{ pb: 2 }}>
            <Typography variant="subtitle2">
              It is a long established fact that a reader will be distracted
            </Typography>
          </Grid>
        </Grid>
      </ListItemWrapper>
      <Divider />
      <ListItemWrapper>
        <ListItem alignItems="center">
          <ListItemAvatar>
            <Avatar alt="John Doe" src={User1} />
          </ListItemAvatar>
          <ListItemText primary="John Doe" />
          <ListItemSecondaryAction>
            <Grid container justifyContent="flex-end">
              <Grid item xs={12}>
                <Typography variant="caption" display="block" gutterBottom>
                  2 min ago
                </Typography>
              </Grid>
            </Grid>
          </ListItemSecondaryAction>
        </ListItem>
        <Grid container direction="column" className="list-container">
          <Grid item xs={12} sx={{ pb: 2 }}>
            <Typography variant="subtitle2">
              It is a long established fact that a reader will be distracted
            </Typography>
          </Grid>
        </Grid>
      </ListItemWrapper> */}
    </List>
  );
};

export default NotificationList;
